import { atom } from 'nanostores'

const $count = atom(1)

export const $isLoadingOverlayOpen = atom(true)

export const loadingOverlay = {
  show: () => {
    $count.set($count.get() + 1)
    $isLoadingOverlayOpen.set(true)
  },
  hide: () => {
    const next = Math.max(0, $count.get() - 1)
    $count.set(next)
    $isLoadingOverlayOpen.set(next > 0)
  },
}
